// extracted by mini-css-extract-plugin
export default {"container":"mca-z","list":"nca-z"};